exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fade-enter-active[data-v-3c2e631e], .fade-leave-active[data-v-3c2e631e] {\n    -webkit-transition: all 0.5s;\n    transition: all 0.5s;\n}\n.fade-enter[data-v-3c2e631e], .fade-leave-to[data-v-3c2e631e] /* .fade-leave-active below version 2.1.8 */ {\n    opacity: 0;\n}\n", ""]);

// exports
